import React from 'react';
import { DownOutlined } from '@ant-design/icons';

import PageTitle from '@components/snippets/PageTitle';
import Badge from '@components/snippets/Badge';
import EditPlaylist from '@components/snippets/EditPlaylist';
import { useTranslation } from 'react-i18next';

function PlaylistTitle({
  playlist,
  playlistDuration,
  onRename,
  onChangeColor,
  onCopy,
  onDelete,
}) {
  const { t } = useTranslation();
  const { color, name, id } = playlist;

  return (
    <PageTitle
      title={
        <>
          <Badge color={color || 'grey'} size="md" />
          {name}
          <EditPlaylist
            name={name}
            color={color}
            icon={<DownOutlined />}
            onRename={onRename(id, playlist, 'name')}
            onChangeColor={onChangeColor(id, playlist, 'color')}
            onCopy={onCopy(id, name)}
            onDelete={onDelete(id)}
          />
        </>
      }
      extra={`${t('duration')}: ${playlistDuration}`}
    />
  );
}

export default PlaylistTitle;
